// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logo from "../assets/images/RLBGR.webp";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Logo and Description */}
        <div className="footer-logo-description">
          <div className="logo"><Link to="/">
            <img
              src={logo}
              alt="Ray Infrastructure Logo"
              className="footer-logo"
            /></Link>
          </div>
          <br />
          <p>
            We provide high-quality engineering and project management
            solutions, focusing on safety, efficiency, and cost-effectiveness.
            Built on integrity and innovation, we strive to create lasting value
            for our clients and industry.
          </p>
          {/* Email Subscription */}<Link to="/Contact">
          <div className="email-subscription"><button className="subscribe-btn">
            Contact us for more information and updates.
            ➔</button>
          </div></Link>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <nav>
            <Link to="/">Home</Link>
            <Link to="/Breakthrough">About Us</Link>
            <Link to="/Breakthrough">Carrer</Link>

            <Link to="/ServicePage">Services</Link>
            <Link to="/RecentProject">Projects</Link>
          </nav>
        </div>

        {/* Services */}
        <div className="footer-links">
          <h4>Services</h4>
          <nav>
            <Link to="/ServicePage">Water Supply</Link>
            <Link to="/ServicePage">Waste Water Management</Link>
            <Link to="/ServicePage">Civil Engineering</Link>
            <Link to="/ServicePage">Transportation</Link>
            <Link to="/ServicePage">Solid Waste Management</Link>
            <Link to="/ServicePage">Coastal Conservation and Development</Link>
          
          </nav>
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <address>
            C.O.: 505, Synergy Tower, Nr Vodafone House, Corporate Rd,
            Prahladnagar, Ahmedabad 380015
            <br />
            +91 79460 01587
            <br />
            <a href="mailto:info@rayinfra.in">info@rayinfra.in</a>
          </address>
            {/* Social Icons */}
            <div className="social-icons" style={{ marginTop: '1rem', display: 'flex', gap: '1rem', justifyContent: 'flex-start' }}>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/ray-infrastructures-private-limited/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-youtube"></i>
            </a>
            </div>
          </div>
          </div>

          {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>Ray Infrastructures Private Limited</p>
        <div className="footer-bottom-links">
          <Link to="/site"> Site Map </Link>
          </div>
      </div>
    </footer>
  );
};

export default Footer;
